<div class="item-list-container mx-3 mb-3">
  <ng-container *ngFor="let item of itemList | orderBy : ['name']; let i = index">  
  <div
    class="row py-2 filter-item pointer-cursor"
    *ngIf="item.name !== ''"
  >
    <div
      class="d-flex flex-row justify-content-center align-items-center col-2"
    >
      <img [src]="icon" class="icon" />
    </div>
    <div
      class="col-8 text-item d-flex flex-row justify-content-between align-items-center"
    >
      <p class="item-title">
        {{ item?.name }}
      </p>
    </div>
    <div
      class="col-2 d-flex flex-row justify-content-center align-items-center pointer-cursor"
      role="button"
      (click)="selectItem(item?.id)"
    >
      <img src="assets/svg/ico-circle.svg" *ngIf="!item?.state" />

      <img
        *ngIf="item?.state"
        src="assets/svg/ico-checkmark-circle-outline.svg"
      />
    </div>
  </div>
</ng-container>
</div>
